// Загрузка расписаний объекта
export const SENDINGS_SCHEDULES_REQUEST =
    "sendings/SCHEDULES_REQUEST";

export const SENDINGS_SCHEDULES_SUCCESS =
    "sendings/SCHEDULES_SUCCESS";

export const SENDINGS_SCHEDULES_FAILURE =
    "sendings/SCHEDULES_FAILURE";

// Список больше не отражает состояние на сервере
export const SENDINGS_SCHEDULES_INVALIDATE =
    "sendings/SCHEDULES_INVALIDATE";

// Загрузка уведомлений объекта
export const SENDINGS_NOTICES_REQUEST =
    "sendings/NOTICES_REQUEST";

export const SENDINGS_NOTICES_SUCCESS =
    "sendings/NOTICES_SUCCESS";

export const SENDINGS_NOTICES_FAILURE =
    "sendings/NOTICES_FAILURE";

// Список уведомлений больше не отражает состояние на сервере
export const SENDINGS_NOTICES_INVALIDATE =
    "sendings/NOTICES_INVALIDATE";

// Загрузка шаблонов расписаний
export const SENDINGS_TEMPLATES_REQUEST =
    "sendings/TEMPLATES_REQUEST";

export const SENDINGS_TEMPLATES_SUCCESS =
    "sendings/TEMPLATES_SUCCESS";

export const SENDINGS_TEMPLATES_FAILURE =
    "sendings/TEMPLATES_FAILURE";

// Загрузка текста отдельного шаблона
export const SENDINGS_TEMPLATE_DETAIL_REQUEST =
    "sendings/TEMPLATE_DETAIL_REQUEST";

export const SENDINGS_TEMPLATE_DETAIL_SUCCESS =
    "sendings/TEMPLATE_DETAIL_SUCCESS";

export const SENDINGS_TEMPLATE_DETAIL_FAILURE =
    "sendings/TEMPLATE_DETAIL_FAILURE";

// Подключённые услуги объекта
export const SENDINGS_SERVICES_REQUEST =
    "sendings/SERVICES_REQUEST";

export const SENDINGS_SERVICES_SUCCESS =
    "sendings/SERVICES_SUCCESS";

export const SENDINGS_SERVICES_FAILURE =
    "sendings/SERVICES_FAILURE";

// Создание и редактирование расписания
export const SENDINGS_SAVE_REQUEST =
    "sendings/SAVE_REQUEST";

export const SENDINGS_SAVE_SUCCESS =
    "sendings/SAVE_SUCCESS";

export const SENDINGS_SAVE_FAILURE =
    "sendings/SAVE_FAILURE";

// Очистка состояния
export const SENDINGS_RESET = "sendings/RESET";
